import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'preact-router';

import EmbeddedHabitatSearchBar from '@/components/EmbeddedHabitatSearchBar';
import HabitatEmbedPanel from '@/components/HabitatEmbedPanel';
import { getHabitatQueryOptions } from '@/queries/habitats';

const EmbeddedHabitat = () => {
  const [{ matches }] = useRouter();
  const { data: habitat } = useQuery(getHabitatQueryOptions(matches?.habitatSlug));

  return (
    <div className="relative flex flex-col md:flex-row">
      <div className="relative bg-primary-green text-white max-md:aspect-video md:h-[588px] md:grow">
        <video
          src={habitat?.heroVideoURL || habitat?.trailer?.videoURL}
          autoPlay
          muted
          loop
          className="preflight preflight-video size-full object-cover"
        />
        {/* Search bar */}
        <div className="absolute inset-0 items-center justify-center p-4 md:flex">
          <EmbeddedHabitatSearchBar placeholder={`Watch ${habitat?.animal ?? 'animals'} and more...`} />
        </div>
      </div>

      <div className="relative shrink-0 bg-white md:h-[588px] md:w-[380px]">
        {habitat && <HabitatEmbedPanel habitatId={habitat._id} animals={habitat.animals} />}
      </div>
    </div>
  );
};

export default EmbeddedHabitat;
